module.exports = __webpack_public_path__ + "fonts/light.802eecb0.ttf";